var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZlatiborLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255.108,
    height: 143.767,
    viewBox: "59 118.904 255.108 143.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "zlatibor live"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M942.762 635.392H913.56v-6.428l22.04-51.333h-21.03v-6.521h28.376v6.429l-22.131 51.333h21.947v6.52Z",
    fillRule: "evenodd",
    fill: "url(\"#a\")",
    transform: "translate(-854.56 -451.563)",
    "data-name": "Path 261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.764 635.392V571.11h7.165v57.762h18.364v6.52h-25.53Z",
    fillRule: "evenodd",
    fill: "url(\"#b\")",
    transform: "translate(-871.949 -451.563)",
    "data-name": "Path 262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1019.102 622.444-2.482 12.948h-6.61l12.304-64.282h10.377l12.306 64.282h-7.162l-2.48-12.948h-16.253Zm.917-6.153h14.325l-7.255-37.099-7.07 37.1Z",
    fillRule: "evenodd",
    fill: "url(\"#c\")",
    transform: "translate(-886.083 -451.563)",
    "data-name": "Path 263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.465 635.392v-57.761h-11.846v-6.521h30.855v6.521h-11.846v57.761h-7.163Z",
    fillRule: "evenodd",
    fill: "url(\"#d\")",
    transform: "translate(-904.584 -451.563)",
    "data-name": "Path 264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.987 571.11v64.282h-7.164V571.11h7.164Z",
    fillRule: "evenodd",
    fill: "url(\"#e\")",
    transform: "translate(-921.973 -451.563)",
    "data-name": "Path 265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.795 571.11c10.01 0 13.958 4.775 13.958 14.234v3.03c0 6.796-1.93 11.02-7.531 12.765 6.245 1.745 8.632 6.703 8.632 13.775v5.418c0 9.642-4.682 15.06-14.693 15.06h-14.785V571.11h14.42Zm-1.745 27.274c5.693 0 8.632-1.836 8.632-8.54v-3.765c0-5.694-1.93-8.448-7.07-8.448h-7.071v20.753h5.509Zm2.11 30.488c5.237 0 7.623-2.755 7.623-8.724v-5.693c0-7.163-2.846-9.551-9-9.551h-6.242v23.968h7.62Z",
    fillRule: "evenodd",
    fill: "url(\"#f\")",
    transform: "translate(-929.017 -451.563)",
    "data-name": "Path 266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.033 586.317c0-9.825 4.868-16.162 14.693-16.162 9.917 0 14.785 6.337 14.785 16.162v33.243c0 9.735-4.868 16.162-14.785 16.162-9.825 0-14.693-6.427-14.693-16.162v-33.243Zm7.07 33.611c0 5.877 2.48 9.275 7.623 9.275 5.233 0 7.622-3.398 7.622-9.275V585.95c0-5.785-2.389-9.275-7.622-9.275-5.144 0-7.623 3.49-7.623 9.275v33.978Z",
    fillRule: "evenodd",
    fill: "url(\"#g\")",
    transform: "translate(-946.227 -451.25)",
    "data-name": "Path 267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.244 571.11c10.1 0 14.325 5.144 14.325 14.693v5.234c0 7.072-2.48 11.48-7.99 13.224 5.877 1.745 8.081 6.52 8.081 13.407v10.011c0 2.846.093 5.51 1.286 7.713h-7.255c-.825-1.836-1.193-3.49-1.193-7.805v-10.102c0-7.255-3.399-9.55-9.367-9.55h-5.05v27.457h-7.165V571.11h14.328Zm-1.838 30.304c5.693 0 9.092-1.836 9.092-8.815v-6.152c0-5.785-2.113-8.816-7.439-8.816h-6.978v23.783h5.325Z",
    fillRule: "evenodd",
    fill: "url(\"#h\")",
    transform: "translate(-963.838 -451.563)",
    "data-name": "Path 268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.537 752.512V688.23h7.162v57.762h18.365v6.52h-25.527Z",
    fillRule: "evenodd",
    fill: "url(\"#i\")",
    transform: "translate(-889.85 -489.841)",
    "data-name": "Path 269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.672 688.23v64.282h-7.163V688.23h7.163Z",
    fillRule: "evenodd",
    fill: "url(\"#j\")",
    transform: "translate(-904.875 -489.841)",
    "data-name": "Path 270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1093.588 688.23 10.469 55.925 10.377-55.925h6.61l-12.03 64.282h-10.56l-12.121-64.282h7.255Z",
    fillRule: "evenodd",
    fill: "url(\"#k\")",
    transform: "translate(-911.028 -489.841)",
    "data-name": "Path 271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.95 716.698v6.428h-15.703v22.866h19.284v6.52h-26.447V688.23h26.447v6.521h-19.284v21.947h15.703Z",
    fillRule: "evenodd",
    fill: "url(\"#l\")",
    transform: "translate(-930.556 -489.841)",
    "data-name": "Path 272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.23,
    y1: 0.553,
    x2: 6.067,
    y2: -0.537,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.951,
    y1: 0.735,
    x2: 5.768,
    y2: -0.354,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -1.363,
    y1: 0.953,
    x2: 3.54,
    y2: -0.137,
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -2.669,
    y1: 1.084,
    x2: 2.89,
    y2: -0.006,
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -15.898,
    y1: 1.246,
    x2: 8.044,
    y2: 0.157,
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -4.257,
    y1: 1.357,
    x2: 1.562,
    y2: 0.268,
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -5.262,
    y1: 1.558,
    x2: 0.557,
    y2: 0.489,
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -6.199,
    y1: 1.778,
    x2: -0.487,
    y2: 0.688,
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -1.108,
    y1: 0.761,
    x2: 5.611,
    y2: -0.329,
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -7.836,
    y1: 0.879,
    x2: 16.113,
    y2: -0.21,
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -1.898,
    y1: 0.991,
    x2: 3.044,
    y2: -0.099,
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -3.784,
    y1: 1.22,
    x2: 2.702,
    y2: 0.13,
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7d300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ad32",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZlatiborLive);
export default __webpack_public_path__ + "static/media/zlatibor-live.2179927b6d559acb148713bc43490733.svg";
export { ForwardRef as ReactComponent };